
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
ul {
      margin-top:0px;
      margin-bottom:0px;
      width:100%;
      list-style-type:none;
      flex-wrap:wrap;
      padding:0px;
      color:var(--neutral-white);
}@media (min-width: 1024px) {ul {
            margin-left:0px;
            margin-right:0px;
      }ul {
            display:flex;
      }ul {
            flex-direction:row;
      }
}ul {
      text-align:center;
}@media (min-width: 1024px) {ul {
            text-align:left;
      }
}ul li {
      margin-left:0px;
      margin-right:0px;
}ul li {
      display:inline-block;
}ul li::after {
      margin-left:0.75rem;
      margin-right:0.75rem;
}ul li::after{
      content:'|';
    }ul li:last-of-type::after {
      visibility:hidden;
}ul li:last-of-type::after {
      margin-left:0px;
      margin-right:0px;
}

a {
      color:var(--neutral-white);
      text-decoration-line:none;
}

a:hover {
      text-decoration-line:underline;
}

:host([site='BH']) ul {
      text-align:center;
}

@media (min-width: 640px) {:host([site='BH']) ul {
            text-align:left;
      }
}

:host([site='BH']) ul li {
      line-height:2.5rem;
}

:host([site='BH']) ul li a {
      font-size:var(--bh-fs-body-01);
      line-height:var(--bh-lh-body-01);
      letter-spacing:var(--bh-ls-body-01);
}

:host([site='BH']) .utility-menu-title {
      padding-top:2rem;
}

:host([site='BH']) .utility-menu-title {
      padding-bottom:1.5rem;
}

:host([site='BH']) .utility-menu-title {
      text-align:center;
}

:host([site='BH']) .utility-menu-title {
      font-size:var(--bh-fs-body-01);
      line-height:var(--bh-lh-body-01);
      letter-spacing:var(--bh-ls-body-01);
}

@media (min-width: 640px) {:host([site='BH']) .utility-menu-title {
            text-align:left;
      }
}

@media (min-width: 640px) {:host([site='BH']) .utility-menu-title {
            font-weight:var(--fw-bold);
      }
}
`;